import React from 'react';
import { IpaType } from '../../phonemes/ipa';

export interface PhonotacticsTableProps {
  readonly onsetToCount: Record<IpaType, number>;
  readonly nucleusToCount: Record<IpaType, number>;
  readonly codaToCount: Record<IpaType, number>;
}

export function PhonotacticsTable(props: PhonotacticsTableProps) {
  const onsets = Object.keys(props.onsetToCount).map(k => k === '' ? '∅' : k).join(' ');
  const nuclei = Object.keys(props.nucleusToCount).map(k => k === '' ? '∅' : k).join(' ');;
  const codas = Object.keys(props.codaToCount).map(k => k === '' ? '∅' : k).join(' ');;

  return (
    <table><tbody>
      <tr>
        <td>onsets</td>
        <td><textarea cols={80} rows={2} spellCheck={false} value={onsets} readOnly={true} /></td>
      </tr>
      <tr>
        <td>nuclei</td>
        <td><textarea cols={80} rows={1} spellCheck={false} value={nuclei} readOnly={true} /></td>
      </tr>
      <tr>
        <td>codas</td>
        <td><textarea cols={80} rows={8} spellCheck={false} value={codas} readOnly={true} /></td>
      </tr>
    </tbody></table>
  );
}
